<template>
    <form
        ref="form"
        :name="name"
        :vid="name"
        @submit.prevent="onSubmit"
    >
        <slot></slot>
    </form>
</template>

<script>
// import { Form } from 'vee-validate';
// import { scrollToError } from '@services/helper.service';

export default {
    name: 'BaseForm',

    components: {
        // Form,
    },

    props: {
        name: {
            type: String,
            default: null,
        },
    },

    emits: ['flags-changed', 'submit'],

    /*
    computed: {
        validation() {
            return this.$refs?.form;
        },
        flags() {
            return this.validation?.flags;
        },
    },

    mounted() {
        this.$watch(
            () => {
                return this.flags;
            },
            (val) => {
                val && this.$emit('flags-changed', val);
            }
        );
    },
    */

    methods: {
        onSubmit(e) {
            try {
                // scrollToError(this.$refs.form);
            } catch (e) {
                console.error(e);
            }

            this.$emit('submit', { event: e, validation: this.validation });
        },
    },
};
</script>
